import { ClaudeAi, GeminiAi, OpenAi, OpenAILogo } from '../../../../../../assets/images';

export const ProviderTabsData = [
  { name: 'openai', logo: OpenAi },
  { name: 'anthropic', logo: ClaudeAi },
  { name: 'google', logo: GeminiAi },
  { name: 'default', logo: OpenAILogo },
];
